<template>
    <Form v-slot="{handleSubmit}" :validation-schema="rules" as="div" :initial-values="initialValues">
        <div :id="!!id ? id : 'modal'"
             class="modal fade"
             :data-bs-backdrop="!!backdropStatic ? 'static' : null"
             tabindex="-1"
             :aria-labelledby="!!id ? '#' . id : null"
             aria-hidden="true"
             :ref="!!id ? id : 'modal'">

            <div class="modal-dialog modal-dialog-centered" :class="!!size ? 'modal-' + size : 'modal-lg'">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title">
                            {{ title }}
                        </h5>

                        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"
                                @click="closeModal"></button>
                    </div>

                    <div class="modal-body">
                        <slot></slot>
                    </div>

                    <div class="modal-footer" v-if="closeButtonText || acceptButtonText">
                        <button type="button" class="btn btn-secondary" @click="closeModal" v-if="closeButtonText">
                            {{ closeButtonText }}
                        </button>

                        <button type="button" class="btn btn-primary" @click="handleSubmit($event, acceptModal)"
                                v-if="acceptButtonText">
                            {{ acceptButtonText }}
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </Form>
</template>

<script>
import {Modal} from "bootstrap";
import {Form} from "vee-validate";

export default {
    name: 'VModalValidated',
    components: {Form},
    props: {
        id: {
            type: String,
            required: false,
            default: 'modal',
        },
        title: {
            type: String,
            required: false,
            default: '',
        },
        closeButtonText: {
            type: String,
            required: false,
        },
        acceptButtonText: {
            type: String,
            required: false,
        },
        size: {
            type: String,
            required: false,
            default: 'lg'
            // TODO: Validator doesn't work, so I can't force it here
        },
        backdropStatic: {
            type: Boolean,
            required: false,
            default: null
        },
        doCloseOnAccept: {
            type: Boolean,
            required: false,
            default: true,
        },
        rules: {
            type: Object,
            required: true,
        },

        acceptEventName: {
            type: String,
            required: false,
            default: 'accepted'
        },
        closeEventName: {
            type: String,
            required: false,
            default: 'closed'
        },
        initialValues: {
            type: Object,
            required: false,
            default: () => {
                return {}
            }
        }
    },
    data() {
        return {
            was_accepted: false,
            formData: {},
            do_emit_on_hide: true,
        }
    },
    mounted() {
        let modal_id = !!this.id ? this.id : 'modal';
        this.modal = new Modal(this.$refs[modal_id]);
        this.modal.show();

        this.$refs[modal_id].addEventListener('hide.bs.modal', () => {
            // We emit just when the event of 'hiding' starts
            if (this.do_emit_on_hide) {
                if (this.was_accepted === true) {
                    this.$emit(this.acceptEventName, this.formData);
                } else {
                    this.$emit(this.closeEventName);
                }
            }
        })
    },
    beforeUnmount() {
        this.hide();
    },
    methods: {
        acceptModal(data) {
            this.was_accepted = true;
            this.formData = data;

            if (this.doCloseOnAccept === true) {
                this.hide();
            } else {
                // We are not hiding modal, so event is not emitted. We force it to be emitted
                this.$emit(this.acceptEventName, this.formData);
            }

            this.was_accepted = false;
        },
        closeModal() {
            this.was_accepted = false;

            this.hide();
        },
        hide() {
            this.modal.hide();
        },
        hideWithoutEmitting() {
            this.do_emit_on_hide = false;
            this.modal.hide();
        }
    },
};
</script>
